(() => {
  const button = document.querySelector('[data-skafe-scroll-top]');
  if (!button) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let ticking = false;
  let visible = false;
  let scrollTimeout = null;
  let isHovering = false;

  // Tie the reveal to the viewport rather than a fixed pixel count: 480px is
  // most of a phone screen but a fifth of a desktop one. Pages that barely
  // scroll never show the button at all, so it cannot sit on screen when
  // returning to the top is not worth a control.
  const showAfter = () => window.innerHeight * 0.75;
  const worthShowing = () =>
    document.documentElement.scrollHeight - window.innerHeight > window.innerHeight * 1.5;

  const setVisible = (next) => {
    if (next === visible) return;
    visible = next;
    button.classList.toggle('is-visible', next);
    button.setAttribute('aria-hidden', next ? 'false' : 'true');
    button.tabIndex = next ? 0 : -1;
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      const shouldShow = worthShowing() && window.scrollY > showAfter();
      
      if (shouldShow) {
        setVisible(true);
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          if (!isHovering) {
            setVisible(false);
          }
        }, 1500);
      } else {
        setVisible(false);
        clearTimeout(scrollTimeout);
      }
    });
  };

  const handleHoverStart = () => {
    isHovering = true;
    clearTimeout(scrollTimeout);
  };

  const handleHoverEnd = () => {
    isHovering = false;
    if (worthShowing() && window.scrollY > showAfter()) {
      scrollTimeout = setTimeout(() => {
        setVisible(false);
      }, 1500);
    }
  };

  button.addEventListener('mouseenter', handleHoverStart);
  button.addEventListener('mouseleave', handleHoverEnd);
  button.addEventListener('focus', handleHoverStart);
  button.addEventListener('blur', handleHoverEnd);

  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: reduceMotion.matches ? 'auto' : 'smooth',
    });
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();
})();
